import React from 'react';
import AnimatedSection from '../../components/AnimatedSection';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <AnimatedSection animation="scale-up" duration="slow">
        <section className="about-hero-full">
          <div className="about-hero-overlay">
            <h1 className="about-hero-title">About</h1>
          </div>
          <img src="/home_1.jpg" alt="About Yolo Production" className="about-hero-image" />
        </section>
      </AnimatedSection>

      <section className="stats-section">
        <div className="stats-container">
          <AnimatedSection animation="fade-up">
            <h2 className="stats-title">Our Photography Achievements</h2>
          </AnimatedSection>
          <div className="stats-grid">
            <AnimatedSection animation="bounce-in" delay={100} className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Events Captured</div>
            </AnimatedSection>
            <AnimatedSection animation="bounce-in" delay={200} className="stat-item">
              <div className="stat-number">200+</div>
              <div className="stat-label">Weddings</div>
            </AnimatedSection>
            <AnimatedSection animation="bounce-in" delay={300} className="stat-item">
              <div className="stat-number">5+</div>
              <div className="stat-label">Years Experience</div>
            </AnimatedSection>
            <AnimatedSection animation="bounce-in" delay={400} className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Client Satisfaction</div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="team-container">
          <AnimatedSection animation="fade-up">
            <h2 className="team-title">Meet Our Photography Team</h2>
          </AnimatedSection>
          <div className="team-grid">
            <AnimatedSection animation="fade-up" delay={100} className="team-member">
              <div className="member-avatar">
                <img src="/yolo-no-name.png" alt="Lead Photographer" className="member-photo" />
              </div>
              <h3 className="member-name">Quang Nguyen</h3>
              <p className="member-role">Lead Photographer</p>
              <p className="member-description">
                Specialized in wedding photography with 10+ years of experience, known for diverse shooting styles and a passion for capturing timeless love stories.
              </p>
            </AnimatedSection>

            <AnimatedSection animation="fade-up" delay={200} className="team-member">
              <div className="member-avatar">
                <img src="/yolo-no-name.png" alt="Lead Photographer" className="member-photo" />
              </div>
              <h3 className="member-name">Sarah Johnson</h3>
              <p className="member-role">Portrait Specialist</p>
              <p className="member-description">
                Expert in portrait and fashion photography with a keen eye for lighting and composition.
              </p>
            </AnimatedSection>

            <AnimatedSection animation="fade-up" delay={300} className="team-member">
              <div className="member-avatar">
                <img src="/home_1.jpg" alt="Event Photographer" className="member-photo" />
              </div>
              <h3 className="member-name">Yolo Team</h3>
              <p className="member-role">Event Photographer</p>
              <p className="member-description">
                A dedicated team of professional event photographers, specializing in corporate and commercial photography. With years of experience and a passion for dynamic event coverage, we work seamlessly together to capture every important moment with creativity, precision, and style.
              </p>
            </AnimatedSection>
          </div>
        </div>
      </section>

      <AnimatedSection animation="fade-up">
        <section className="equipment-section"
          style={{ backgroundImage: 'url(/equiptmentbg.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundColor: 'transparent' }}
        >
          <div className="equipment-container">
            <AnimatedSection animation="fade-down">
              <h2 className="equipment-title">Professional Equipment</h2>
              <p className="equipment-description">
                Our studio invests in world-class gear — from high-end cameras and lenses to industry-leading lighting and editing tools — ensuring every photo and video is captured with precision, artistry, and timeless beauty.
              </p>
            </AnimatedSection>
            <div className="equipment-grid">
              <AnimatedSection animation="scale-up" delay={100} className="equipment-item">
                <div className="equipment-icon">
                  <img src="/cannon.jpeg" alt="Canon Camera" className="equipment-image" />
                </div>
                <h3 className="equipment-name">Canon EOS R5 & Sony A7R IV</h3>
                <p className="equipment-description">Cutting-edge mirrorless cameras delivering ultra-high resolution and breathtaking detail.</p>
              </AnimatedSection>
              <AnimatedSection animation="scale-up" delay={200} className="equipment-item">
                <div className="equipment-icon">
                  <img src="/cannon.jpeg" alt="Canon Camera" className="equipment-image" />
                </div>
                <h3 className="equipment-name">Profoto & Godox Lighting</h3>
                <p className="equipment-description">Studio-grade lighting systems that create perfect ambiance, whether indoor or outdoor.</p>
              </AnimatedSection>
              <AnimatedSection animation="scale-up" delay={300} className="equipment-item">
                <div className="equipment-icon">
                  <img src="/cannon.jpeg" alt="Canon Camera" className="equipment-image" />
                </div>
                <h3 className="equipment-name">4K/6K Video Capabilities</h3>
                <p className="equipment-description">Cinematic video production with gimbal stabilization for smooth, film-like motion.</p>
              </AnimatedSection>
              <AnimatedSection animation="scale-up" delay={400} className="equipment-item">
                <div className="equipment-icon">
                  <img src="/cannon.jpeg" alt="Canon Camera" className="equipment-image" />
                </div>
                <h3 className="equipment-name">Adobe Creative Suite</h3>
                <p className="equipment-description">Professional editing in Lightroom, Photoshop, and Premiere Pro for flawless final results.</p>
              </AnimatedSection>
            </div>
          </div>
        </section>
      </AnimatedSection>

      <AnimatedSection animation="fade-up">
        <section className="cta-section">
          <div className="cta-container">
            <AnimatedSection animation="bounce-in">
              <h2 className="cta-title">Ready to Capture Your Story?</h2>
            </AnimatedSection>
            <AnimatedSection animation="fade-up" delay={200}>
              <p className="cta-description">
                Let's discuss your photography needs and create beautiful memories together.
                Every moment deserves to be captured with artistry and care.
              </p>
            </AnimatedSection>
            <AnimatedSection animation="scale-up" delay={400}>
              <button className="btn btn-primary btn-large">Book a Consultation</button>
            </AnimatedSection>
          </div>
        </section>
      </AnimatedSection>
    </div>
  );
};

export default AboutPage;
